import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/userCollection';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';
import axios from 'axios';

//Synchronous
const cancelToken = axios.CancelToken;
//Asynchronous
export const createUserCollection = (associationData, callback) => {
    return (dispatch) => {
        axiosInstance.post(serverRoutes.UserCollection.crud(), associationData)
            .then((response) => {
                dispatch({
                    type: Types.CREATE_USER_COLLECTION,
                    payload: response.data
                });
                callback(null, response.data);
            })
            .catch((err) => {
                const message = err.response?.data?.error || 'Erro ao criar associação';
                callback(message); 
                console.error('Erro ao criar associação:', message);
            });
    };
};


export const updateUserCollection = (userId, associationData, callback) => {
    return (dispatch) => {
        axiosInstance.put(serverRoutes.UserCollection.crud(`/${userId}`), associationData)
            .then((response) => {
                callback();
                dispatch({
                    type: Types.UPDATE_USER_COLLECTION,
                    payload: response.data
                });
                toast.success("Associação atualizada com sucesso!", { autoClose: 10000 });
            })
            .catch((err) => {
                callback(false)
                console.log(err)
                toast.error("Erro ao atualizar associação.", { autoClose: 10000 });
            })
    }
}

export const updateApiToken = (associationId, callback) => {
    return (dispatch) => {
        axiosInstance.put(serverRoutes.UserCollection.updateApiToken(`/${associationId}`))
            .then((response) => {
                dispatch({
                    type: Types.UPDATE_API_TOKEN,
                    payload: response.data
                });
                if (typeof callback === 'function') {
                    callback(true);
                }
                toast.success("Token de conjunto atualizado com sucesso!", { autoClose: 10000 });
            })
            .catch((err) => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                console.log(err)
                toast.error("Erro ao atualizar token de conjunto.", { autoClose: 10000 });
            })
    }
}

export const updateJdbcPassword = (associationId, callback) => {
    return (dispatch) => {
        axiosInstance.put(serverRoutes.UserCollection.updateJdbcPassword(`/${associationId}`))
            .then((response) => {
                dispatch({
                    type: Types.UPDATE_JDBC_PASSWORD,
                    payload: response.data
                });
                if (typeof callback === 'function') {
                    callback();
                }
                toast.success("Senha de conexão JDBC atualizada com sucesso!", { autoClose: 10000 });
            })
            .catch((err) => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                console.log(err)
                toast.error("Erro ao atualizar senha de conexão JDBC.", { autoClose: 10000 });
            })
    }
}

export const getAllAssociations = (page, limit, query, sort) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.UserCollection.crud('', { page, limit, query, sort }))
            .then((response) => {
                dispatch({
                    type: Types.GET_USER_COLLECTIONS,
                    payload: response.data
                })
            })
            .catch((err) => {
                console.log(err)
                dispatch({
                    type: Types.GET_USER_COLLECTIONS,
                    payload: []
                });
            })
    }
}

let cancelUserAllCollections;

export const getAllUserCollections = (collectioname, username, systemslug, queryType, isCatalog) => {
    return (dispatch, getState) => {
        if (getState().userCollection.loading) {
            if (cancelUserAllCollections) {
                cancelUserAllCollections();
            }
        }

        dispatch({
            type: Types.GET_USER_COLLECTION,
            payload: []
        });
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.UserCollection.get(collectioname, username, systemslug, { querytype: queryType, isCatalog: isCatalog }), {
            cancelToken: new cancelToken((c) => {
                cancelUserAllCollections = c;
            })
        })
            .then((response) => {
                dispatch({
                    type: Types.GET_USER_COLLECTION,
                    payload: response.data
                });
            })
            .catch((err) => {
                console.log(err)
                dispatch({
                    type: Types.GET_USER_COLLECTION,
                    payload: []
                });
            })
    }
}

export const deleteUserCollection = (userId, collectionId, callback) => {
    return (dispatch) => {
        axiosInstance.delete(serverRoutes.UserCollection.crud(`/${userId}/${collectionId}`))
            .then((response) => {
                callback();
                dispatch({
                    type: Types.DELETE_USER_COLLECTION,
                    payload: response.data
                });
                toast.success("Associação deletada com sucesso!", { autoClose: 10000 });
            })
            .catch((err) => {
                console.log(err);
                toast.error("Erro ao deletar associação.", { autoClose: 10000 });
            })
    }
}

export const getApiTokens = (systemSlug) => {
    return (dispatch) => {
        axiosInstance.get(serverRoutes.UserCollection.get(undefined, undefined, systemSlug, { querytype: 'api', isCatalog: false }))
            .then((response) => {
                dispatch({
                    type: Types.GET_API_TOKENS,
                    payload: response.data
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({
                    type: Types.GET_API_TOKENS,
                    payload: []
                });
            });
    };
};

export const getUserPostgresTables = (username) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_POSTGRES_LOADING
        });
        axiosInstance.get(serverRoutes.UserCollection.getUserPostgresTables(username))
            .then((response) => {
                dispatch({
                    type: Types.GET_POSTGRES_TOKENS,
                    payload: response.data
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({
                    type: Types.GET_POSTGRES_TOKENS,
                    payload: []
                });
            });
    };
};

export const getSystemPostgresTables = (system) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_POSTGRES_LOADING
        });
        axiosInstance.get(serverRoutes.UserCollection.getSystemPostgresTables(system))
            .then((response) => {
                dispatch({
                    type: Types.GET_POSTGRES_TOKENS,
                    payload: response.data
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({
                    type: Types.GET_POSTGRES_TOKENS,
                    payload: []
                });
            });
    };
};

export const getJdbcTokens = (systemSlug) => {
    return (dispatch) => {
        axiosInstance.get(serverRoutes.UserCollection.get(undefined, undefined, systemSlug, { querytype: 'jdbc', isCatalog: false }))
            .then((response) => {
                dispatch({
                    type: Types.GET_JDBC_TOKENS,
                    payload: response.data
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({
                    type: Types.GET_JDBC_TOKENS,
                    payload: []
                });
            });
    };
};


export const getJdbcDmTokens = (systemSlug) => {
    return (dispatch) => {
        axiosInstance.get(serverRoutes.UserCollection.get(undefined, undefined, systemSlug, { querytype: 'jdbc_dm', isCatalog: false }))
            .then((response) => {
                dispatch({
                    type: Types.GET_JDBC_DM_TOKENS,
                    payload: response.data
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({
                    type: Types.GET_JDBC_DM_TOKENS,
                    payload: []
                });
            });
    };
};

export const getAllJdbcUserCollections = (collectioname, username, systemslug, isCatalog) => {
    return (dispatch, getState) => {
        if (getState().userCollection.loading) {
            if (cancelUserAllCollections) {
                cancelUserAllCollections();
            }
        }

        dispatch({
            type: Types.GET_USER_COLLECTION,
            payload: []
        });
        dispatch({
            type: Types.SET_LOADING
        });

        // Promise para ambas as requisições
        Promise.all([
            axiosInstance.get(serverRoutes.UserCollection.get(collectioname, username, systemslug, { querytype: 'jdbc', isCatalog: isCatalog }), {
                cancelToken: new cancelToken((c) => {
                    cancelUserAllCollections = c;
                })
            }),
            axiosInstance.get(serverRoutes.UserCollection.get(collectioname, username, systemslug, { querytype: 'jdbc_dm', isCatalog: isCatalog }), {
                cancelToken: new cancelToken((c) => {
                    cancelUserAllCollections = c;
                })
            })
        ])
            .then(([jdbcResponse, jdbcDmResponse]) => {
                // Combinar os dados de ambas as requisições
                const combinedData = [
                    ...(Array.isArray(jdbcResponse.data) ? jdbcResponse.data : []),
                    ...(Array.isArray(jdbcDmResponse.data) ? jdbcDmResponse.data : [])
                ];
                dispatch({
                    type: Types.GET_USER_COLLECTION,
                    payload: combinedData
                });
            })
            .catch((err) => {
                console.log(err)
                dispatch({
                    type: Types.GET_USER_COLLECTION,
                    payload: []
                });
            })
    }
};
